export const environment = {
	production: false,
	api: 'https://api-secure.kurdshopping.net/public/api/',
	stripe_key: 'pk_test_QN9W7jWZ6a3iOlgzk58Alsxb',
	firebaseApiKey: 'AIzaSyDrlSGfsadNJIo8aH2SDkCibVUPCPWHZtk',
	AMPLITUDE_KEY: '8852aa06ef07d160727cc993380e8cda',
	GOOGLE_ADSENSE: {
		display: 'block',
		adClient: 'ca-pub-4420492646195713',
		isEnabled: false,
		banner: {
			adSlot: '2243863577',
			className: 'google-ad-banner',
		},
		feed: {
			adSlot: '1719504992',
			adFormat: 'fluid',
			layoutKey: '-7b+do+50-2p-8c',
			className: 'google-ad',
		},
		multiplex: {
			adSlot: '9073414669',
			className: 'google-ad',
		},
	},
	SENTRY: {
		dsn: 'https://2d921db91bae48bbb23d546f9a14a0d0@o1354220.ingest.sentry.io/4505368847187968',
	},
	FIREBASE: {
		apiKey: 'AIzaSyDrlSGfsadNJIo8aH2SDkCibVUPCPWHZtk',
		authDomain: 'kurdshopping-6861a.firebaseapp.com',
		databaseURL: 'https://kurdshopping-6861a.firebaseio.com',
		projectId: 'kurdshopping-6861a',
		storageBucket: 'kurdshopping-6861a.appspot.com',
		messagingSenderId: '539319119319',
		appId: '1:539319119319:web:ea537301b13f42acc4ef92',
		measurementId: 'G-XH3HC1R7BP',
		recaptchaEnterpriseKey: '6LfqHKImAAAAAIjfk77vR2VrA2G_BvTj8GfXL0vR',
	},
	WHATSAPP: {
		callForHelpUrl: 'https://wa.me/message/ZPFMXIC3LSYXO1?phone=9647512347071',
		callForDetails: 'https://api.whatsapp.com/send?phone=',
	},
    s3BaseUrl: "https://stag-assets.kurdshopping.net"
};
